/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState } from 'react';
import { LinkButton } from '@blend/enterprise-components';

import { TermsAndConditionsModal } from 'blb-components/TermsAndConditionsModal';
import { PrivacyPolicyModal } from 'blb-components/PrivacyPolicyModal';

export namespace ComplianceInputLabel {
  export interface Props {}
}

export const ComplianceInputLabel: React.FC<{}> = () => {
  const [areTermsAndConditionsOpen, setTermsAndConditionsOpen] = useState<boolean>(false);
  const [isPrivacyPolicyOpen, setPrivacyPolicyOpen] = useState<boolean>(false);
  return (
    <span>
      I confirm that I have read and agree to the{' '}
      <LinkButton
        btnSize="sm"
        id="it-TermsAndConditions"
        inline
        label="Terms of Use"
        onClick={() => setTermsAndConditionsOpen(true)}
      />{' '}
      and{' '}
      <LinkButton
        btnSize="sm"
        id="it-PrivacyPolicy"
        inline
        label="Privacy Policy"
        onClick={() => setPrivacyPolicyOpen(true)}
      />
      .
      <TermsAndConditionsModal
        btnLabel="Done"
        handleClose={() => setTermsAndConditionsOpen(false)}
        isOpen={areTermsAndConditionsOpen}
      />
      <PrivacyPolicyModal handleClose={() => setPrivacyPolicyOpen(false)} isOpen={isPrivacyPolicyOpen} />
    </span>
  );
};
